import { createContext, RefObject, useContext } from 'react'
import { noop } from '@manychat/manyui'

import {
  GoalEditorMode,
  SubmitRef,
} from 'apps/aiAutomation/components/EngagementGoalEditor/lib/types'
import {
  GoalEditorContextMissingError,
  GoalEditorTypeMismatchError,
} from 'apps/aiAutomation/errors'
import { EngagementGoal, GoalType } from 'shared/api/requests/aiEngagementGoal/schemas'

interface GoalEditorContextProps<Goal extends EngagementGoal | null = EngagementGoal | null> {
  mode: GoalEditorMode
  goalId: string
  goal: Goal
  editorRef: RefObject<SubmitRef<EngagementGoal> | null> | null
  save: (goal: EngagementGoal, saveAndPublish?: boolean) => Promise<void> | void
  changeMode: (mode: GoalEditorMode) => void
}

export const GoalEditorContext = createContext<GoalEditorContextProps>({
  mode: GoalEditorMode.CREATE,
  goalId: '',
  goal: null,
  editorRef: null,
  save: noop,
  changeMode: noop,
})

export const useGoalEditorContext = <Type extends GoalType>(goalType: Type) => {
  const context = useContext(GoalEditorContext)

  if (!context) {
    throw new GoalEditorContextMissingError()
  }

  if (context.goal && context.goal.type !== goalType) {
    throw new GoalEditorTypeMismatchError(goalType, context.goal.type)
  }

  return context as GoalEditorContextProps<Extract<EngagementGoal, { type: Type }>>
}
